import { Component, isDevMode } from '@angular/core';

/**
 * Dev viewport probe: a triangular corner badge fixed to the top-left of the
 * viewport, printing the active breakpoint name through the global
 * `fu-breakpoint-name` class (`global.scss`), as the `fu-title-block` breakpoint
 * cell does, so it tracks a resize live and costs no change detection.
 *
 * Opt in per browser profile with a truthy `localStorage['fu-breakpoint-badge']`;
 * the pre-paint script in `index.original.html` mirrors that flag onto `<html>`
 * as a class of the same name and the stylesheet keys off it, so showing the
 * badge is pure CSS and never touches hydration. A development build is the only
 * one that renders the element at all - the `isDevMode()` gate lives here rather
 * than at the call site, so mounting the component cannot leak the probe.
 */
@Component({
  selector: 'fu-dev-breakpoint-badge',
  template: `
    @if (isDevMode) {
      <div class="dbb" aria-hidden="true">
        <span class="dbb-label fu-breakpoint-name"></span>
      </div>
    }
  `,
  styleUrls: ['./dev-breakpoint-badge.component.scss'],
  host: {
    class: 'fu-dev-breakpoint-badge',
  },
})
export class DevBreakpointBadgeComponent {
  /** Identical on the server and the client, so the `@if` is hydration-safe. */
  protected readonly isDevMode = isDevMode();
}
